<template>
  <div>
    <el-card class="box-card" style="margin: 40px;">
      <div slot="header" class="clearfix">
        <span>渠道广告</span>
        <el-button style="float: right; margin-right: 10px;" @click="addcad" type="success" icon="el-icon-edit" >新增</el-button>
      </div>
      <div class="text item">
        <div class="source">
          <el-row>
            <el-col :span="12">
              <el-form>
              <el-form-item label="广告选择:">
                <el-select v-model="gginfo" filterable clearable placeholder="请选择广告" @change="queryselectgg">
                  <el-option
                    v-for="item in gglist"
                    :key="item.APP_ID"
                    :label="item.APP_NAME"
                    :value="item.APP_ID"
                  >
                    <span style="float: left">{{ item.APP_NAME }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.APP_ID }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row class="querypanel">
            <el-table
              stripe
              :data="qdad"
              ref="multipleTable">
              <el-table-column
                prop="APP_NAME"
                label="广告名称">
              </el-table-column>
              <el-table-column
                prop="NAME"
                label="渠道标识">
              </el-table-column>
              <el-table-column
                prop="RATE"
                label="比率">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.RATE" placeholder="请输入内容"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="状态">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.NewState"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="120px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="更新记录" placement="top-start">
                    <i class="fa fa-edit fa-lg ciicon curpointer" v-on:click="upcad(scope.$index, qdad)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="测试" placement="top-start">
                    <i class="fa fa-check-circle fa-lg ciicon curpointer" v-on:click="testcad(scope.$index, qdad)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="生成渠道链接" placement="top-start">
                    <i class="fa fa-external-link fa-lg ciicon curpointer" v-on:click="makelink(scope.$index, qdad)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>
      </div>
    </el-card>
    <el-dialog title="新增渠道" :visible.sync="qdaddvis">
      <el-row class="querypanel">
        <div>
          <el-form label-width="120px" label-position="left">
            <el-col :span="12">
              <el-form-item label="广告选择:">
                <el-select v-model="gginfo" filterable clearable placeholder="请选择广告" @change="selectgg">
                  <el-option
                    v-for="item in gglist"
                    :key="item.APP_ID"
                    :label="item.APP_NAME"
                    :value="item.APP_ID"
                  >
                    <span style="float: left">{{ item.APP_NAME }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.APP_ID }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道选择:">
                <el-select v-model="qdinfo" filterable clearable placeholder="请选择渠道">
                  <el-option
                    v-for="item in qdlist"
                    :key="item.COMPANY_KEY"
                    :label="item.NAME"
                    :value="item.COMPANY_KEY"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-row>
      <el-button style="margin-top: 20px" @click="addcadinfo">分配给渠道</el-button>
    </el-dialog>
    <el-dialog title="渠道测试" :visible.sync="qdtestvis">
      <el-row class="querypanel">
      <div>
            <el-form label-width="120px" label-position="left">
            <el-col :span="24">
                <el-form-item label="IDFA:">
                  <el-input v-model="idfa" placeholder="请输入IDFA"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="IP:" >
                  <el-input v-model="ip" placeholder="请输入IP"></el-input>
                </el-form-item>
            </el-col>
              <el-col :span="24">
                <el-form-item label="UA:" >
                  <el-input v-model="ua" placeholder="非必填"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="TS:" >
                  <el-input v-model="ts" placeholder="非必填">
                    <el-button slot="append" @click="getts" icon="el-icon-search"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="CallBack:" >
                  <el-input v-model="callback" placeholder="非必填"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
      </div>
      </el-row>
      <el-button style="margin-top: 20px" @click="begintest">开始测试</el-button>
    </el-dialog>
    <el-dialog :title="makelinkdes" :visible.sync="qdmakelinkvis">
      <el-row class="querypanel">
        <div style="color: #000000">
          {{linkinfo}}
        </div>
      </el-row>
      <el-row class="querypanel">
        <div style="color: darkgreen">
          {{newlinkinfo}}
        </div>
      </el-row>
      <div style="margin-top: 10px;">
        <p  class="copy-code-button" :data-clipboard-text="linkinfo" @click="copyurl">
          复制旧链接
        </p>
        <p style="margin-top: 20px; background-color: green" class="copy-code-button" :data-clipboard-text="newlinkinfo" @click="copyurl">
          复制新链接
        </p>
      </div>
      </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import Clipboard from 'clipboard'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'QueryCInfo',
    data () {
      return {
        qdad: [],
        qdtestvis: false,
        qdaddvis: false,
        qdmakelinkvis: false,
        idfa: '82E3CC92-0FE3-485F-92E9-34A53560340F',
        ip: '121.69.96.246',
        ua: '',
        callback: '',
        gglist: [],
        ts: '',
        gginfo: '',
        qdlist: [],
        qdinfo: '',
        linkinfo: '',
        newlinkinfo: '',
        makelinkdes: '',
        curaddata: ''
      }
    },
    mounted: function () {
      that = this
      that.$options.methods.queryqd()
      that.$options.methods.querygg()
      that.$options.methods.queryqdinfo()
    },
    methods: {
      getts () {
        this.ts = new Date().getTime();
      },
      copyurl () {
        var clipboard = new Clipboard('.copy-code-button') // 这里可以理解为选择器，选择上面的复制按钮
        window.console.log('准备复制')
        clipboard.on('success', e => {
          this.$message('复制成功')
          window.console.log(e)
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
          window.console.log(e)
          this.$message('手机权限不支持复制功能')
          // 释放内存
          clipboard.destroy()
        })
      },
      querygg () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getads',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.gglist = res.data
            } else {
              that.gglist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryqdinfo () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getchannels',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.qdlist = res.data
            } else {
              that.qdlist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addcad () {
        this.qdaddvis = true
      },
      queryselectgg (value) {
        window.console.log(value)
        if (value === '') {
          that.$options.methods.queryqd()
        } else {
          var qstr = {
            pid: value
          }
          that.$http({
            url: 'http://api.jiyuewuxian.cn/querychannelad',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              window.console.log(res)
              if (res.status === 200) {
                that.qdad = []
                for (var i = 0; i < res.data.length; i++) {
                  var subdata = res.data[i]
                  var datatmp = encodeURI(res.data[i].STATE)
                  window.console.log(datatmp.substr(datatmp.length-1,1))
                  if (datatmp.substr(datatmp.length-1,1) === '1') {
                    subdata.NewState = true
                  } else {
                    subdata.NewState = false
                  }
                  that.qdad.push(subdata)
                }
              } else {
                that.qdad = []
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      addcadinfo () {
        if (this.gginfo !== '' && this.qdinfo !== '') {
          var adddata = {
            cid: this.qdinfo,
            pid: this.gginfo,
            rate: '100',
            state: '1'
          }
          that.$http({
            url: 'http://api.jiyuewuxian.cn/addchannel',
            method: 'post',
            data: adddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.status === 200) {
                that.$message('渠道广告添加完毕!');
                that.$options.methods.queryqd()
                that.qdaddvis = false
              }
            })
            .catch(function (error) {
              window.console.log('error' + error)
            })
        } else {
          this.$message('信息不完整')
        }
      },
      begintest () {
        if (this.idfa !== '' && this.ip !== '') {
          var testdata = {
            appName: that.curaddata.APP_NAME,
            callbackUrl: '',
            idfa: this.idfa,
            ip: this.ip,
            mac: '',
            name: that.curaddata.NAME,
            ua: '',
            ts: that.ts
          }
          that.$http({
            url: 'http://39.104.70.224:9091/api/companyInfo/api/testsend/',
            method: 'post',
            data:testdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              window.console.log(res)
              if (res.data.code === '200') {
                that.$message(res.data.result)
              } else {
                that.$message('测试失败')
              }
            })
            .catch(function (error) {
              window.console.log('error' + error)
            })
        } else {
          this.$message('信息不完整')
        }
      },
      upcad (index,data) {
        window.console.log(data[index])
        this.$confirm('确认修改吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          var state = '1'
          window.console.log(data[index].NewState)
          if (data[index].NewState) {
            state = '1'
          } else {
            state = '0'
          }
          var adddata = {
            id: data[index].ID.toString(),
            cid: data[index].CID,
            pid: data[index].PID,
            rate: data[index].RATE.toString(),
            state: state
          }
          that.$http({
            url: 'http://api.jiyuewuxian.cn/replacechannel',
            method: 'post',
            data: adddata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.status === 200) {
                that.$message('渠道广告更新完毕!');
                that.$options.methods.queryqd()
                that.qdaddvis = false
              }
            })
            .catch(function (error) {
              window.console.log('error' + error)
            })
        })
      },
      testcad (index,data) {
        window.console.log(data[index])
        this.qdtestvis = true
        this.curaddata = data[index]
      },
      makelink (index,data) {
        window.console.log(data[index])
        this.qdmakelinkvis = true
        var seldata = data[index]
        this.makelinkdes = seldata.APP_NAME + ' | ' + seldata.NAME
        that.linkinfo = 'http://www.jiyuewuxian.cn:9095/jiyue/companyInfo/api/click?appId=' + seldata.PID + '&companyKey='+ seldata.CID +'&idfa={idfa}&ip={ip}&callback={callback}'
        that.newlinkinfo = 'http://api.jiyuewuxian.cn/jyclick?pid=' + seldata.PID + '&cid='+ seldata.CID +'&idfa={idfa}&caid={caid}&ip={caid}&callback={callback}&ua=&ts=&clickid='
      },
      queryqd () {
        var qstr = {
          limit: ''
        }
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getchannelad',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.qdad = []
              for (var i = 0; i < res.data.length; i++) {
                var subdata = res.data[i]
                var datatmp = encodeURI(res.data[i].STATE)
                window.console.log(datatmp.substr(datatmp.length-1,1))
                if (datatmp.substr(datatmp.length-1,1) === '1') {
                  subdata.NewState = true
                } else {
                  subdata.NewState = false
                }
                that.qdad.push(subdata)
              }
            } else {
              that.qdad = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>
  .querypanel {
    width: 100%;
    /* margin-top: 10px; */
    /* border: 1px solid #ebebeb; */
    /* padding: 30px; */
    /* border-radius: 3px; */
    /* -webkit-transition: .2s; */
    /* transition: .2s; */
  }
  .copy-code-button {
    margin-top: 10px;
    color: #fff;
    background-color: #1989fa;
    border: 1px solid #1989fa;
    position: relative;
    display: inline-block;
    border-radius: 40px;
    box-sizing: border-box;
    width: 100%;
    height: 44px;
    margin: 0;
    padding: 0;
    font-size: 16px;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
    -webkit-appearance: none;
    -webkit-text-size-adjust: 100%;
  }
  .gtopicon {
    font-size: 14px;
    padding-left: 15px;
  }
  .treerow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .treerowinput {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-right: 8px;
    width:200px;
  }
  .treeop {
    flex: 1;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: flex-end;
  }

  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/gg/QueryCAd.vue